/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Sales {

    import fld = SalesItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class SalesItemsEditor extends _Ext.ItemGridEditor<SalesItemsRow> {
        protected getColumnsKey() { return "Sales.SalesItems"; }
        protected getDialogType() { return SalesItemsDialog; }
        protected getLocalTextPrefix() { return SalesItemsRow.localTextPrefix; }

        protected form: SalesItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        public ProductTypeId: number;
        public useMF: boolean;
        public selectedboms = [];


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SalesMasterDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU
            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {
                    Quantity += x.Pieces;
                };

                if (Quantity > 0) {
                    var Item = StockID.pop();
                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;
            Q.first(columns, x => x.field === fld.Discount).format = amt;
            Q.first(columns, x => x.field === fld.UnitRate).format = amt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;

            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                AttributeId: item.AttributeId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );


            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (value > CurrentStock.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than available stock', 2500, false);
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }

                item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                if (item.WstPer != null) {
                    item.WstWt = item.NetWeight * (item.WstPer / 100);
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                }
                item[field] = value;

            }

            //}

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId != 101) {
                if (value > CurrentStock.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than available stock', 1000, false);
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                }
                item[field] = value;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 1000, false);
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                item.NetWeight = value;
                if (item.WstPer != null) {
                    item.WstWt = value * (item.WstPer / 100);
                }
                if (item.CalcOnId != 3) {
                    var Net = ((item.UnitRate + item.UnitLabour) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;

            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var Net = (item.Weight * value) + item.UnitLabour;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var Net = (item.Pieces * value) + item.UnitLabour;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }

                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }


            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as SalesMasterDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            let returnvalue: string = "";

            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            if (input.hasClass('weight'))
                returnvalue = Q.formatNumber(value, '0.000');

            if (input.hasClass('amount'))
                returnvalue = q.formatAmount(value);

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        //#endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as SalesMasterDialog).RateListId;
            this.LaborListId = (this.parentDialog as SalesMasterDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as SalesMasterDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as SalesMasterDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as SalesMasterDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as SalesMasterDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as SalesMasterDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as SalesMasterDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as SalesMasterDialog).form.PartyId.value);
            this.useMF = (this.parentDialog as SalesMasterDialog).useMF;
        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid

            var mf = 0;
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "stock-button",
                hotkey: "alt+k",
                onClick: () => {
                    this.setMasterValues();
                    var x = this.PartyId;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId) || this.PartyId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }
                    else {
                        if (this.useMF) {
                            mf = (this.parentDialog as SalesMasterDialog).form.MF.value;
                            if (mf == null || mf == 0) {
                                Q.notifyWarning("Please Enter MF Value to proceed");
                                return;
                            }
                        }
                        var filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        for (let Itemdetail of ItemDetails) {
                            if (Itemdetail.RefVoucherId == 32)
                                Itemdetail.RefVoucherId = 0
                            var mf = (this.parentDialog as SalesMasterDialog).form.MF.value;
                            if (mf > 0) {
                                Itemdetail.MF = mf;
                                var _Itemdetail = RateHelper.ReCalculateMarkUp(Itemdetail.MF, Itemdetail.MFAmount, Itemdetail.BOMDetails, Itemdetail.LaborDetails, Itemdetail.Pieces, Itemdetail.Weight, Itemdetail.NetWeight
                                    , Itemdetail.FancyCharges, Itemdetail.OtherCharges);
                                Itemdetail.BOMDetails = _Itemdetail.BOMDetails;
                                Itemdetail.LaborDetails = _Itemdetail.LaborDetails;
                                Itemdetail.UnitLabour = _Itemdetail.UnitLabour;
                                Itemdetail.UnitRate = _Itemdetail.UnitRate;
                                Itemdetail.UnitCost = _Itemdetail.UnitCost;
                                Itemdetail.GrossAmount = _Itemdetail.GrossAmount;
                            }
                            Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Itemdetail);
                        }
                    }
                    pickerDialog.dialogOpen();

                }
            });

            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+o",
                onClick: () => {
                    var grid = SalesOrder.OrderItemsGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId) || this.PartyId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }
                    else {
                        if (this.useMF) {
                            mf = (this.parentDialog as SalesMasterDialog).form.MF.value;
                            if (mf == null || mf == 0) {
                                Q.notifyWarning("Please Enter MF Value to proceed");
                                return;
                            }
                        }
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: true
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();

                }
            });
            buttons.push({
                title: "Select Approval",
                cssClass: "approval-button",
                hotkey: "alt+a",
                onClick: () => {
                    var grid = SalesApprovalItemsGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    }
                    else {
                        if (this.useMF) {
                            mf = (this.parentDialog as SalesMasterDialog).form.MF.value;
                            if (mf == null || mf == 0) {
                                Q.notifyWarning("Please Enter MF Value to proceed");
                                return;
                            }
                        }
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();

                }
            });

            buttons.push({
                title: "Materials",
                cssClass: "approval-button",
                hotkey: "alt+a",
                onClick: () => {
                    var x = this.selectedboms;
                    SelectedBOMDialog.selectedboms = x;
                    var grid = new SelectedBOMDialog();
                    grid.items = this.view.getItems();
                    this.setMasterValues();

                    grid.element.bind('dialogclose', () => {

                        var isclosed = grid.isclosed;
                        if (isclosed) {
                            this.selectedboms = SelectedBOMDialog.selectedboms;
                            this.element.trigger('dialogclose');
                        }
                    });
                    //var dialog = new Serenity.EntityDialog(grid);
                    if (x.length == 0) {
                        alert('No Products Selected');
                    } else {
                        grid.dialogOpen();

                    }
                    Serenity.SubDialogHelper.bindToDataChange(grid, this, (e, dci) => {
                        this.refresh();
                    }, true);

                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }

        // #region Set Data

        setData(ItemDetails: any[]) {

            for (let Itemdetail of ItemDetails) {
                var mf = (this.parentDialog as SalesMasterDialog).form.MF.value;
                if (mf > 0) {
                    Itemdetail.MF = mf;
                    var _Itemdetail = RateHelper.ReCalculateMarkUp(Itemdetail.MF, Itemdetail.MFAmount, Itemdetail.BOMDetails, Itemdetail.LaborDetails, Itemdetail.Pieces, Itemdetail.Weight, Itemdetail.NetWeight
                        , Itemdetail.FancyCharges, Itemdetail.OtherCharges);
                    Itemdetail.BOMDetails = _Itemdetail.BOMDetails;
                    Itemdetail.LaborDetails = _Itemdetail.LaborDetails;
                    Itemdetail.UnitLabour = _Itemdetail.UnitLabour;
                    Itemdetail.UnitRate = _Itemdetail.UnitRate;
                    Itemdetail.UnitCost = _Itemdetail.UnitCost;
                    Itemdetail.GrossAmount = _Itemdetail.GrossAmount;
                }
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


    }
}